module.exports = __webpack_public_path__ + "img/57.71872a6d.png";